module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart-window:title":"Название графика","export":"Экспортировать","duplicate":"Дублировать","delete":"Удалить"},"en":{"chart-window:title":"Chart title","export":"Export","duplicate":"Duplicate","delete":"Delete"}}')
  delete Component.options._Ctor
}
